import { useState, useEffect } from "react";
import { Navbar, Container, Nav } from "react-bootstrap";
import logo from '../assets/img/logo3.png';
import navIcon1 from '../assets/img/nav-icon1.svg';
import navIcon2 from '../assets/img/nav-icon2.svg';
import navIcon3 from '../assets/img/nav-icon3.svg';
import { LanguageSwitcher } from './LanguageSwitcher';
import { TranslatedText } from './TranslatedText';

export const NavBar = () => {
  const [activeLink, setActiveLink] = useState('home');
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    }

    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const onUpdateActiveLink = (value) => {
    setActiveLink(value);
  }

  return (
    <Navbar expand="lg" className={scrolled ? "scrolled" : ""}>
      <Container>
        <Navbar.Brand href="#home">
          <img src={logo} alt="Logo" />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav">
          <span className="navbar-toggler-icon"></span>
        </Navbar.Toggle>
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link 
              href="#home" 
              className={activeLink === 'home' ? 'active navbar-link' : 'navbar-link'} 
              onClick={() => onUpdateActiveLink('home')}
            >
              <TranslatedText textKey="home" />
            </Nav.Link>
            <Nav.Link 
              href="#skills" 
              className={activeLink === 'skills' ? 'active navbar-link' : 'navbar-link'} 
              onClick={() => onUpdateActiveLink('skills')}
            >
              <TranslatedText textKey="skills" />
            </Nav.Link>
            <Nav.Link 
              href="#projects"  
              className={activeLink === 'projects' ? 'active navbar-link' : 'navbar-link'} 
              onClick={() => onUpdateActiveLink('projects')}
            >
              <TranslatedText textKey="projects" />
            </Nav.Link>
            <Nav.Link 
              href="#contact"  
              className={activeLink === 'contact' ? 'active navbar-link' : 'navbar-link'} 
              onClick={() => onUpdateActiveLink('contact')}
            >
              <TranslatedText textKey="contact" />
            </Nav.Link>
            <Nav.Link 
              href="#guestbook"  
              className={activeLink === 'guestbook' ? 'active navbar-link' : 'navbar-link'} 
              onClick={() => onUpdateActiveLink('guestbook')}
            >
              <TranslatedText textKey="guestbook" />
            </Nav.Link>
          </Nav>
          <span className="navbar-text">
            <div className="social-icon">
              <a href="https://www.linkedin.com/in/yi-si-0b4081163/"><img src={navIcon1} alt="LinkedIn" /></a>
              <a href="https://www.facebook.com/profile.php?id=100013350452455"><img src={navIcon2} alt="Facebook" /></a>
              <a href="https://www.instagram.com/nisisiyishou/"><img src={navIcon3} alt="Instagram" /></a>
            </div>
            <LanguageSwitcher />
          </span>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}